import update from 'immutability-helper';

import { SET, ADDED, UPDATED, DELETED } from './actions';
import * as questionsActions from "../questions/actions";

const initialState = {};

export const reducer = (state = initialState, action) => {
  switch (action.type) {

    case SET:
      return action.scalePoints;

    case ADDED:
      return {
        ...state,
        [action.scalePoint.id]: action.scalePoint
      };

    case UPDATED:
      return update(state, {
        [action.scalePoint.id]: {
          $set: action.scalePoint
        }
      });
    case DELETED:
      return update(state, {
        $unset: [action.scalePoint.id]
      });

    case questionsActions.TYPE_UPDATED:
      const ids = [];

      _.each(state, scalePoint => {
        if (scalePoint.question.id === action.expiredId)
          ids.push(scalePoint.id);
      });

      return update(state, {
        $unset: ids
      });

    default:
      return state;
  }
};